import React from "react";


const DesktopShimmer = () => (
  <>
    <div
        style={{
          background: "#f6f7f8",
          backgroundImage: `linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
      )`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "800px 104px",
          display: "inline-block",
          width: "100%",
          position: "relative",
          height: "65px",
          WebkitAnimationDuration: "1s",
          WebkitAnimationFillMode: "forwards",
          WebkitAnimationIterationCount: "infinite",
          WebkitAnimationName: "placeholderShimmer",
          WebkitAnimationTimingFunction: "linear",
        }}
      ></div>
    <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
      <div
          style={{
            display: "flex",
            width: "80%",
            justifyContent: "space-between",
            marginTop: "20px",
            height: "120px",
          }}
        >
        <div
            style={{
              background: "#f6f7f8",
              backgroundImage: `linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
      )`,
              backgroundRepeat: "no-repeat",
              borderRadius: "8px",
              width: "70%",
              WebkitAnimationDuration: "1s",
              WebkitAnimationFillMode: "forwards",
              WebkitAnimationIterationCount: "infinite",
              WebkitAnimationName: "placeholderShimmer",
              WebkitAnimationTimingFunction: "linear",
            }}
          ></div>
        <div
            style={{
              background: "#f6f7f8",
              backgroundImage: `linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
      )`,
              backgroundRepeat: "no-repeat",
              borderRadius: "8px",
              width: "28%",
              WebkitAnimationDuration: "1s",
              WebkitAnimationFillMode: "forwards",
              WebkitAnimationIterationCount: "infinite",
              WebkitAnimationName: "placeholderShimmer",
              WebkitAnimationTimingFunction: "linear",
            }}
          ></div>
      </div>
      <div
          style={{
            display: "flex",
            width: "80%",
            justifyContent: "space-between",
            marginTop: "20px",
            height: "290px",
          }}
        >
        <div
            style={{
              display: "flex",
              height: "100%",
              width: "70%",
              justifyContent: "space-between",
            }}
          >
          <div
              style={{
                background: "#f6f7f8",
                backgroundImage: `linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
      )`,
                backgroundRepeat: "no-repeat",
                borderRadius: "8px",
                width: "31%",
                WebkitAnimationDuration: "1s",
                WebkitAnimationFillMode: "forwards",
                WebkitAnimationIterationCount: "infinite",
                WebkitAnimationName: "placeholderShimmer",
                WebkitAnimationTimingFunction: "linear",
              }}
            ></div>
          <div
              style={{
                background: "#f6f7f8",
                backgroundImage: `linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
      )`,
                backgroundRepeat: "no-repeat",
                borderRadius: "8px",
                width: "31%",
                WebkitAnimationDuration: "1s",
                WebkitAnimationFillMode: "forwards",
                WebkitAnimationIterationCount: "infinite",
                WebkitAnimationName: "placeholderShimmer",
                WebkitAnimationTimingFunction: "linear",
              }}
            ></div>
          <div
              style={{
                background: "#f6f7f8",
                backgroundImage: `linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
      )`,
                backgroundRepeat: "no-repeat",
                borderRadius: "8px",
                width: "31%",
                WebkitAnimationDuration: "1s",
                WebkitAnimationFillMode: "forwards",
                WebkitAnimationIterationCount: "infinite",
                WebkitAnimationName: "placeholderShimmer",
                WebkitAnimationTimingFunction: "linear",
              }}
            ></div>
        </div>
        <div
            style={{
              background: "#f6f7f8",
              backgroundImage: `linear-gradient(
        to right,
        #f6f7f8 0%,
        #edeef1 20%,
        #f6f7f8 40%,
        #f6f7f8 100%
      )`,
              backgroundRepeat: "no-repeat",
              borderRadius: "8px",
              width: "28%",
              WebkitAnimationDuration: "1s",
              WebkitAnimationFillMode: "forwards",
              WebkitAnimationIterationCount: "infinite",
              WebkitAnimationName: "placeholderShimmer",
              WebkitAnimationTimingFunction: "linear",
            }}
          ></div>
      </div>
    </div>
  </>
  );

const MsiteHeader = ({ headerTitle }: { headerTitle: string }) => {
  const mobileHeaderLayoutStyle = {
    width: "100%",
    display: "flex",
    backgroundColor: "#fff",
    boxShadow: "rgb(0 0 0 / 10%) 0px -1px 0px inset",
    letterSpacing: "-0.14px",
    fontSize: "20px",
    fontWeight: 600,
    minHeight: "42px",
    alignItems: "center",
    position: "fixed",
    top: 0,
    lineHeight: 1.42857,
  };
  const arrowLayoutStyle = {
    position: "absolute",
    left: 0,
    lineHeight: "21px",
    fontSize: "18px",
    padding: "10px 16px 8px 22px",
    border: 0,
  };
  const headerTextLayoutStyle = {
    display: "flex",
    flex: 1,
    marginLeft: "50px",
    padding: "12px",
    letterSpacing: "-0.14px",
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: "Inter, sans-serif",
  };
  const backIconStyle = {
    width: "20px",
    height: "22px",
  };
  const BACK_ICON = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/1Arrow_back.svg";
  return (
    <div style={mobileHeaderLayoutStyle}>
      <div style={arrowLayoutStyle}>
        <img style={backIconStyle} src={BACK_ICON} alt="back icon"/>
      </div>
      <div style={headerTextLayoutStyle}>
        <span>{headerTitle}</span>
      </div>
    </div>
  );
};

const MsiteShimmer = ({ headerTitle, pageUrl }: { headerTitle: string; pageUrl: string }) => {
  let styleConfigs = [
    {
      style: {
        background: "#f6f7f8",
        backgroundImage: "linear-gradient(to right, #f8f8f8 8%, #eeeeee 18%, #f8f8f8 33%)",
        backgroundRepeat: "no-repeat",
        borderRadius: "8px",
        width: "100%",
        height: "174px",
        marginTop: "72px",
        WebkitAnimationDuration: "1s",
        WebkitAnimationFillMode: "forwards",
        WebkitAnimationIterationCount: "infinite",
        WebkitAnimationName: "placeholderShimmer",
        WebkitAnimationTimingFunction: "linear",
      },
      childrens: [],
    },
    // {
    //   style: {
    //     background: "#f6f7f8",
    //     backgroundImage: `linear-gradient(to right, #f8f8f8 8%, #eeeeee 18%, #f8f8f8 33%)`,
    //     backgroundRepeat: "no-repeat",
    //     borderRadius: "8px",
    //     width: "63%",
    //     height: "34px",
    //     marginTop: "25px",
    //     WebkitAnimationDuration: "1s",
    //     WebkitAnimationFillMode: "forwards",
    //     WebkitAnimationIterationCount: "infinite",
    //     WebkitAnimationName: "placeholderShimmer",
    //     WebkitAnimationTimingFunction: "linear",
    //   },
    //   childrens: [],
    // },
    // {
    //   style: {
    //     background: "#f6f7f8",
    //     backgroundImage: `linear-gradient(to right, #f8f8f8 8%, #eeeeee 18%, #f8f8f8 33%)`,
    //     backgroundRepeat: "no-repeat",
    //     borderRadius: "8px",
    //     width: "100%",
    //     height: "79px",
    //     marginTop: "10px",
    //     WebkitAnimationDuration: "1s",
    //     WebkitAnimationFillMode: "forwards",
    //     WebkitAnimationIterationCount: "infinite",
    //     WebkitAnimationName: "placeholderShimmer",
    //     WebkitAnimationTimingFunction: "linear",
    //   },
    //   childrens: [],
    // },
    // {
    //   style: {
    //     background: "#f6f7f8",
    //     backgroundImage: `linear-gradient(to right, #f8f8f8 8%, #eeeeee 18%, #f8f8f8 33%)`,
    //     backgroundRepeat: "no-repeat",
    //     borderRadius: "8px",
    //     width: "100%",
    //     height: "250px",
    //     marginTop: "20px",
    //     WebkitAnimationDuration: "1s",
    //     WebkitAnimationFillMode: "forwards",
    //     WebkitAnimationIterationCount: "infinite",
    //     WebkitAnimationName: "placeholderShimmer",
    //     WebkitAnimationTimingFunction: "linear",
    //   },
    //   childrens: [],
    // },
  ];

  if (pageUrl.includes("postPayment")) {
    styleConfigs = [];
  }

  return (
    <>
      <MsiteHeader headerTitle={headerTitle} />
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          flexWrap: "wrap",
          // width: "100%",
          padding: "0px 15px 0px 15px",
          margin: "0px 8px 0px 8px",
        }}
      >
        {styleConfigs.map((config, index) => (
          <div style={config?.style} key={index}></div>
        ))}
      </div>
    </>
  );
};

const MsiteSinglePageShimmer = ({
  headerTitle,
}: {
  headerTitle: string;
}) => {
  // only for beauty need to implement for men, fashion
  const loaderStyle = {
    position: "fixed" as const,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 5,
    backgroundColor: "rgba(17,19,20,0.64)",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
  };

  const playerLayoutStyle = {
    position: "relative" as const,
    background: "#FFFFFF",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    width: "88px",
    height: "88px",
    borderRadius: "16px",
    padding: "16px",
    marginTop: "-18px",
  };

  const spinnerStyle = {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #fc2779",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  return (
    <>
      <div style={loaderStyle}>
        <div style={playerLayoutStyle}>
          <div style={spinnerStyle} />
        </div>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export const Shimmer = ({
  isDesktop,
  headerTitle,
  pageUrl,
  isSingleCheckoutPage,
}: {
  isDesktop: boolean;
  headerTitle: string;
  pageUrl: string;
  isSingleCheckoutPage: boolean;
}) => (
  <div id="load-shimmer">
    {isDesktop ? (
      <DesktopShimmer />
      ) : isSingleCheckoutPage ? (
        <MsiteSinglePageShimmer headerTitle={headerTitle} />
      ) : (
        <MsiteShimmer headerTitle={headerTitle} pageUrl={pageUrl} />
      )}
  </div>
  );
